import * as actionTypes from '../types/tabs';

export function setSelectTab(payload) {
  return {
    type: actionTypes.SET_SELECT_TAB,
    payload
  };
}
